export type DescriptionHeadingProps = {
  title: string;
  description: string;
};

const DescriptionHeadings: React.FC<DescriptionHeadingProps> = ({
  title,
  description,
}) => {
  return (
    <div className="border-b border-gray-200 pb-5 w-full">
      <h3 className="text-base font-semibold leading-6 text-gray-900">
        {title}
      </h3>
      <p className="mt-2 text-sm text-gray-500 w-full">{description}</p>
    </div>
  );
};

export default DescriptionHeadings;
